{
    "userCalendarTitle": "Your agenda",
    "userCalendarIsLoading": "Chargement de votre agenda...",
    "userCalendarIsEmpty": "Votre agenda est vide!"
  }
  